exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23GHwxeXPOGdKlyhD2lXep{\n    padding: 5px 10px;\n    display: inline-block;\n}", ""]);

// exports
exports.locals = {
	"toolbarItem": "_23GHwxeXPOGdKlyhD2lXep"
};